export default {
    admin: {
        title: 'admin',
        superadmin: {
            title: 'Super Admin',
            edit: 'editar'
        },
        invite: {
            manage: 'Convide embaixadores da comunidade',
            resend: 'reenviar',
            resend_success: 'Convite foi ressentido',
        },
        events: {
            edit: {
                singular: 'Evento de edição',
                plural: 'Editar eventos',
            },
            overview: 'eventos',
        },
        organizations: {
            edit: {
                singular: 'editar organização e marca',
                plural: 'Editar organizações e marcas',
            },
            overview: 'organizações e marcas',
        },
        pages: {
            edit: {
                singular: 'Página de edição',
                plural: 'editar páginas',
            },
            update: {
                success: 'página atualizada',
                singular: "página de atualização",
                title: "título",
                content: "contente",
                update_success: "página atualizada com sucesso"
            },
            overview: 'páginas',
            title: 'título',
            content: 'contente',
        },
        prices: {
            update: {
                success: 'preços atualizados',
                singular: "Atualizar preços",
                title: "título",
                content: "contente",
                update_success: "Os preços atualizados com sucesso"
            },
            success: 'Compre sucesso',
        },
        users: {
            edit: {
                singular: 'editar usuário',
                plural: 'editar usuários',
            },
            active: 'Ativo',
            passive: 'Passivo',
            overview: 'usuárias',
            impersonate: {
                button: 'Personificar',
                loading: 'Carregando...',
                error: 'Não foi possível personificar este usuário.',
            },
        },
        // LA-194: the links Admin hands out so an organiser can submit
        // an event without having an account.
        submission_links: {
            title: 'Links de envio',
            intro: 'Links que permitem aos organizadores enviar um evento sem conta.',
            new: 'Novo link',
            new_hint: 'Cria um link para dar a um organizador por WhatsApp ou e-mail.',
            create: 'Criar link',
            created: 'Link criado',
            search: 'Pesquisar',
            copy: 'Copiar link',
            withdraw: 'Retirar',
            reactivate: 'Reativar',
            no_brand: 'Ainda sem marca',
            empty: 'Ainda não há links.',
            failed: 'Algo correu mal.',
            has_submissions: 'Já chegaram envios por este link; retira-o em vez de o apagar.',
            delete_confirm: 'Apagar o link {code}?',
            fields: {
                code: 'Código',
                label: 'Descrição',
                label_placeholder: 'ex. Salsa Nights Rotterdam',
                brand: 'Marca',
                brand_placeholder: 'Procurar uma marca',
                brand_hint: 'Opcional. Define a que marca pertence o envio.',
                state: 'Estado',
                submissions: 'Envios',
                expires_at: 'Expira a',
                max_submissions: 'Máx. envios',
                contact_name: 'Contacto',
                contact_email: 'Endereço de e-mail',
            },
            states: {
                all: 'Todos',
                active: 'Ativo',
                expired: 'Expirado',
                withdrawn: 'Retirado',
                full: 'Cheio',
            },
        },
        scraped_concepts: {
            title: 'Scraped Concepts', overview: 'Concepts Overview', edit: { title: 'Edit Concept' },
            columns: { source: 'Source', name: 'Name', dates: 'Dates', location: 'Location', organization: 'Organization', status: 'Status', brand_match: 'Marca', actions: 'Actions' },
            filters: { name: 'Event name', source: 'Source', status: 'Status', city: 'City', date_from: 'Date from', date_to: 'Date to', brand_status: 'Estado da marca' },

            brand_status: {
                unchecked: 'Ainda não verificado',
                unmatched: 'Ainda não está no LatinMap',
                unmanaged: 'Existe, sem gestor',
                review: 'Verificar',
                managed: 'Com gestor',
            },
            match_signal: {
                email: 'encontrada por e-mail',
                domain: 'encontrada por site',
                name: 'encontrada por nome',
                name_city: 'encontrada por nome + cidade',
                fuzzy: 'nome parecido — verificar',
            },
            unlink_brand: 'Desassociar marca',
            organization_unlinked: 'Marca desassociada',
            unlink_confirm: {
                title: 'Desassociar marca?',
                submit: 'Sim, desassociar',
                body: 'Remover a ligação entre "{event}" e a marca "{brand}"?',
                note: 'O conceito permanece na lista e pode ser associado a outra marca. Nada é eliminado.',
            },
            link_confirm: {
                title: 'Associar marca?',
                submit: 'Sim, associar',
                body: 'Associar "{event}" à marca "{brand}"? O evento ainda tem de ser aprovado separadamente.',
                signal: 'Encontrado:',
                warning_managed: 'Esta marca é gerida ativamente por um Professional. Associar um evento recolhido pode colidir com o trabalho dele.',
                warning_review: 'Esta correspondência não é certa. Confirme que se trata mesmo da mesma marca antes de associar.',
            },
            link_match: 'Associar esta marca',
            refresh_matches: 'Atualizar correspondências',
            refresh_matches_help: 'Recalcular a que marcas existentes pertencem os organizadores recolhidos',
            matches_refreshed: 'Correspondências atualizadas: {certain} certas, {possible} a verificar',
            bulk: {
                selected: '{count} selecionados',
                link_matched: 'Associar marca encontrada',
                approve: 'Aprovar',
                reject: 'Rejeitar',
                clear: 'Limpar seleção',
                running: 'A processar...',
                select_all: 'Selecionar tudo nesta página',
                select_one: 'Selecionar {name}',
                nothing_to_link: 'Nada na seleção tem uma correspondência certa',
                nothing_to_unlink: 'Nada na seleção tem uma marca associada',
                unlink: 'Desassociar',
                result: '{succeeded} processados, {failed} ignorados',
                confirm: {
                    title: 'Confirmar ação em massa',
                    submit: 'Sim, continuar',
                    body_approve: 'Publicar {count} conceito(s)? Os que não têm marca confirmada ou certa são ignorados.',
                    body_reject: 'Rejeitar {count} conceito(s)?',
                    body_unlink: 'Remover a ligação de marca de {count} conceito(s)?',
                    unlink_skipped: '{skipped} da seleção são ignorados: não têm marca associada.',
                    body_assign: 'Associar {count} conceito(s) à marca encontrada? Os eventos ainda têm de ser aprovados separadamente.',
                    assign_skipped: '{skipped} da seleção são ignorados: já associados ou sem correspondência certa.',
                    and_more: 'e mais {count}',
                    assign_managed: '{count} destas marcas são geridas ativamente por um Professional. Associar pode colidir com o trabalho deles.',
                },
            },
            status_labels: { pending: 'Pending', approved: 'Approved', rejected: 'Rejected' },
            no_organization: 'No organization assigned', no_results: 'No concepts found', assign_first: 'Please assign an organization first',
            assign_organization: 'Assign Organization', search_organization: 'Search organization by name', current_organization: 'Currently assigned',
            organization_assigned: 'Organization assigned successfully', approve: 'Approve', reject: 'Reject',
            approved_success: 'Concept approved and event created', rejected_success: 'Concept rejected', approve_error: 'Failed to approve',
            save_success: 'Concept saved', scraped_at: 'Scraped at', view_source: 'View source', photos: 'Photos', admin_notes: 'Admin notes',
            reject_confirm: { title: 'Reject Concept', body: 'Are you sure you want to reject this concept?', submit: 'Reject' },
            search_btn: 'Search',
            back: 'Back',
            missing_fields: 'Please fill in the required fields',
            scraping: 'Scraping',
            scrape_result: 'Fetched {fetched}, created {created}, skipped {skipped}, errors {errors}',
        },
        report: {
            details: 'detalhes:',
            reported: 'relatado por:',
            suspended_at: 'suspenso em:',
            email: 'e-mail:',
            phonenumber: 'número de telefone',
            message: 'mensagem:',
            singular: 'relatório',
            plural: 'Relatórios',
            reportables: {
                event: 'eventos',
                organization: 'organizações',
            },
            status: {
                submitted: 'Enviada',
                under_review: 'Em revisão',
                resolved: 'Resolvida',
                no_issue: 'Nenhum problema',
            },
            reportables_by_type: {
                event: 'evento',
                organisation: 'organizações e marcas',
                user: "usuária",
                created_by: 'criado por',
                report_by: 'relatório por',
                ip_adress: 'IP-Adress',
                reason: 'razão',
                description: 'descrição',
                empty: 'vazia',
            },
            no_reports: 'Nenhum relato encontrado',
        },
        lead: {
            singular: 'liderar',
            plural: {
                event: 'Líder do evento',
                organization: 'líder da marca'
            }
        },
        block_user: {
            plural: 'Bloquear usuários',

            title: 'bloqueado',
            description: 'Sua conta foi bloqueada, você não tem mais acesso à plataforma.'
        },
        setting: {
            plural: 'configurações',
            reset: {
                warning: {
                    title: 'Redefina todas as configurações no administrador.',
                    body: 'Tem certeza de que deseja redefinir todas as configurações?'
                }
            }
        },
        permissions: {
            plural: 'permissões',
            levels: {
                'level-1': 'Super Admin',
                'level-2': 'admin',
                'level-3': 'embaixadora',
                'level-4': 'membro premium',
                'level-5': 'membro profissional',
                'level-6': 'membro',
            },
            no_users_with_role: 'Não há usuários com esse nível de função.',
            rights: {
                'create-organization-on-behalf-of-other-user': 'Crie organização em nome de outro usuário',
                'latinmap-verify': 'Grant LatinMap Verificado Status',
                invite: {
                    'level-3': 'Convide embaixadores da comunidade',
                },
                reports: {
                    view: 'Ver relatórios',
                    delete: {
                        any: 'Exclua qualquer relatório',
                    },
                    update: 'Atualizar status do relatório',
                    export: 'Relatórios de exportação',
                },
                events: {
                    create: 'criar eventos',
                    view: 'Ver eventos',
                    update: {
                        any: 'Atualize qualquer evento',
                        own: 'atualizar eventos próprios',
                    },
                    delete: {
                        any: 'Exclua qualquer evento',
                        own: 'excluir eventos próprios',
                    },
                    publish: 'publicar eventos',
                    unpublish: 'não publicado eventos',
                    ownership: {
                        own: 'Mudar a propriedade de eventos próprios',
                        any: 'Alterar a propriedade de qualquer evento',
                    },
                    ticketshop: {
                        enable: 'Ativar Ticketshop',
                    },
                },
                organisations: {
                    create: 'Crie organizações e marcas',
                    update: {
                        any: 'Atualize quaisquer organizações e marcas',
                        own: 'Atualizar organizações e marcas próprias',
                    },
                    delete: {
                        any: 'Exclua todas as organizações e marcas',
                        own: 'Excluir organizações e marcas próprias',
                    },
                    ownership: {
                        own: 'mudar a propriedade de organizações e marcas próprias',
                        any: 'mudar a propriedade de qualquer organização e marcas',
                    },
                },
                users: {
                    edit: 'editar usuários',
                },
                leads: {
                    view: 'Ver leads',
                    delete: 'excluir leads',
                },
                transfer_requests: {
                    view: 'visualizar solicitações de transferência',
                    approve: 'Aprovar solicitações de transferência',
                }
            }
        },
        dance_styles: {
            title: 'Estilos de dança',
            singular: 'estilo de dança',
            create: {
                singular: 'Crie estilo de dança',
            },
            edit: {
                singular: 'Editar estilo de dança',
                plural: 'Editar estilos de dança',
            },
            delete: {
                title: 'Excluir estilo de dança?',
                singular: 'excluir',
                cancel: 'cancelar',
                confirmation: 'Este estilo de dança tem estilos de sub -dança.',
                affected: 'Esse estilo de dança é usado em {event_count} eventos e {organization_count} organizações.',
                label: 'Exclua o estilo de dança',
                placeholder: 'Digite {keyword} aqui e envie para remover este estilo de dança.',
            },
            sub_dance_style: 'Estilo de sub -dança',
            is_favorite: 'é favorito',
        },
        music_styles: {
            title: 'Estilos musicais',
            singular: 'estilo musical',
            create: {
                singular: 'Crie estilo musical',
            },
            edit: {
                singular: 'Edite estilo musical',
                plural: 'Edite estilos musicais',
            },
            delete: {
                title: 'Excluir estilo musical?',
                singular: 'excluir',
                cancel: 'cancelar',
                confirmation: 'Este estilo musical tem estilos de subs música.',
                affected: 'Esse estilo musical é usado em {event_count} Events e {organization_count} organizações.',
                label: 'Exclua estilo musical',
                placeholder: 'Wpisz tutaj "{keyword}" i prześlij, aby usunąć ten styl muzyczny.',
                substyles: 'Esse estilo musical tem estilos sub-músicos.',
            },
            sub_dance_style: 'Estilo de sub -dança',
            sub_music_style: 'Sub Music Style',
            is_favorite: 'é favorito',
        },
        featuredEvent: 'evento em destaque',
        event_types: {
            edit: {
                plural: 'Editar tipos de eventos',
            }
        },
        brand_types: {
            edit: {
                plural: 'Editar tipos de marca',
            }
        },
        prof_financial_title: 'Centro Financeiro',
        modoration:
        {
            title: 'moderação',
        },
        official_brands: 'offical brands',
        export: {
            overview: {
                title: 'exportação e transferências',
                subtitle: 'Exportar todas as organizações, um link de transferência será gerado para cada organização.'
            },
            create: 'criar exportação',
            copied_link: 'link copiado',
            take_ownership: 'tomar propriedade',
            validate_phone: 'Para se apropriar desta organização, você primeiro precisa validar seu número de telefone, isso pode ser feito abaixo:',
            require_login: 'Para se apropriar desta organização, você primeiro precisa fazer login ou criar uma conta, isso pode ser feito abaixo:',
            to_login: 'para fazer login',
            messages: {
                opened: 'Seu link de transferência foi ativado com sucesso, você tem 30 dias para concluir o processo.',
                continue: 'Seu link de transferência foi reaberto com sucesso, finalize o processo de transferência.',
                no_key: 'Nenhuma chave foi fornecida, isso pode acontecer se você atualizar a página, você deve abrir o link original novamente.',
                not_exists: 'Atualmente, não há link de transferência para esta organização.',
                unauthorized: "Você não está autorizado a aceitar esta transferência de organização.",
                expired: 'Este link expirou.',
                already_completed: 'Este link já foi concluído e não pode mais ser usado.',
                transferred: 'A organização foi transferida com sucesso.'
            },
            warning: {
                title: 'Excluir link de transferência',
                body: 'tem certeza de que deseja excluir este link de transferência?'
            },
            status: {
                no_action: 'não transferido',
                opened: 'aberto',
                completed: 'transferido',
                expired: 'expirada'
            }
        },
        duplications: 'duplicações',
        suspend_toggle: {
            warning: {
                title: 'alternar a suspensão',
                body: 'Tem certeza de que deseja alterar a suspensão disso?'
            }
        },
        take_offline: {
            warning: {
                title: 'Tire offline',
                body: 'Você tem certeza de que deseja levar isso offline, não será mais visível para os usuários.'
            }
        },
        bring_online: {
            warning: {
                title: 'Colocar online',
                body: 'Você tem certeza de que deseja colocar isso online? Isso será visível para os usuários.'
            }
        },
        'carousel-image': {
            plural: "Imagens do carrossel",
            overview: {
                title: "Imagens do carrossel",
                subtitle: "Gerencie as imagens do carrossel na página inicial."
            },
            create: {
                singular: "Criar imagem do carrossel",
                success: "Imagem do carrossel criada com sucesso",
                error: "Erro ao criar a imagem do carrossel"
            },
            delete: {
                success: "Imagem do carrossel excluída com sucesso",
                error: "Erro ao excluir a imagem do carrossel"
            },
            image: "Imagem",
            visibility: 'segundos visíveis',
            title: "Título",
            order_by: "Ordenar por",
            warning: {
                body: "Tem certeza de que deseja excluir esta imagem do carrossel? Esta ação não pode ser desfeita.",
                title: "Excluir imagem do carrossel"
            },
        },
        'beta-feature': {
            plural: 'Recursos beta',
            overview: {
                title: 'Recursos beta',
                subtitle: 'Gerenciar recursos beta disponíveis para usuários.',
                success: 'Recurso beta atualizado com sucesso',
                error: 'Erro ao atualizar o recurso beta',
            },
            key: 'Chave',
            name: 'Nome',
            description: 'Descrição',
            visible_to_admins: 'Visível para administradores',
            visible_to_users: 'Visível para usuários',
        }
    },
    nav_headers: {
        agenda: {
            label: 'Agenda Latin',
            options: {
                all_events: 'Todos os Eventos',
                latin_festivals_and_congresses: 'Festivais e Congressos Latin',
                latin_parties_and_socials: 'Festas e Sociais em Latin'
            }
        },
        dance_schools: {
            label: 'Escolas de Dança Latin',
            options: {
                dance_schools: 'Escolas de Dança',
                try_outs_and_start_courses: 'Experimente e Inicie os Cursos',
                workshops_and_bootcamps: 'Workshops e Bootcamps',
                about_the_latin_dance_scene: 'Sobre a Cena de Dança Latin'
            }
        },
        community: {
            label: 'Comunidade Latin',
            options: {
                teachers: 'Professoras',
                show_performers_and_teams: 'Mostrar Artistas e Equipes',
                djs: 'DJs',
                live_bands: 'Bandas ao vivo',
                media_photo_video: 'Mídia, Foto, Vídeo',
                mcs: 'MC\'s'
            }
        },
        dancewear_and_shoes: {
            label: 'Roupas de Dança Latin e Sapatos',
            options: {
                dancewear_and_shoes: 'Roupas de Dança e Sapatos'
            }
        },
        for_professionals: {
            label: 'Para Profissionais',
            options: {
                create_a_brand: 'Como Criar uma Marca',
                create_an_event: 'Como Criar um Evento',
                promote_your_event: 'Como Promover seu Evento',
                professional_account_verification: 'Verificação de Conta Profissional'
            }
        },
        join: {
            label: 'Junte -se ao LatinMap',
            options: {
                create_a_brand_or_organization: 'Criar uma Marca ou Organização',
                become_an_ambassador: 'Torne -se um Embaixador'
            }
        },
        manage_and_promote: {
            label: 'Gerenciar e Promover',
            options: {
                my_events: 'Meus Eventos',
                promote_your_event: 'Promova seu Evento'
            }
        }
    },
    impersonation: {
        banner: 'Você está visualizando como {name}',
        stop: 'Parar de personificar',
    },
    menu_headers: {
        general_title: 'em geral',
        orders_title: 'minhas ordens',
        settings_title: 'configurações',
        professional_title: 'profissional',
        prof_financial_title: 'meu centro financeiro',
        special_access_title: 'Acesso especial',
        community_dashboard_title: 'Meu embaixador do painel da comunidade',
        session_title: 'sessão',
    },
    account: {
        organization_settings_title: 'Configurações da Organização',
        selected_organization: 'Organização selecionada',
        my_events: 'meus eventos',
        role: 'papel',
        dashboard: "painel",
        default_filters: "minhas pesquisas",
        login: "Conecte-se",
        logout: "logout",
        sign_in: "entrar",
        sign_up: "inscrever-se",
        email_address: "endereço de email",
        password: "senha",
        password_repeat: "Repita a senha",
        password_reset: "redefinição de senha",
        password_forgot: "Senha esquecida",
        reset_password: "redefinir senha",
        current_password: "Senha atual",
        change_password: "alterar a senha",
        new_password: "Nova Senha",
        password_reset_success: "redefinição de senha bem -sucedida",
        forgot_password: "Esqueceu sua senha",
        not_a_member: "Not a member",
        i_already_have_an_account: "Eu já tenho uma conta",
        i_accept_the: "Eu aceito o",
        terms_and_conditions: "termos e Condições",
        first_name: "primeiro nome",
        last_name: "sobrenome",
        postal_code: "código postal",
        street_number: "número da rua",
        city: "cidade",
        country: "país",
        preferred_language: "Idioma preferido",
        date_of_birth: "data de nascimento",
        create: "criar uma conta",
        my_account: "minha conta",
        my_professional_dashboard: "meu painel profissional",
        ambassador_dashboard: "Painel de embaixador",
        my_organisations: "minhas organizações e marcas",
        my_organisations_description: "Gerencie suas organizações e marcas",
        singular: "conta",
        phone: "número de telefone",
        phone_verification_token: "Token de verificação de telefone",
        name: "nome",
        user_name: "nome de usuário",
        resend_verification: "Reenviar a verificação",
        update_error: 'Atualizando sua conta falhou.',
        myLatinmap: "Meu LatinMap",
        dancerprofile: "Perfil dos meus bailarinos",
        orders: 'minhas ordens',
        phone_verification: 'Verificação do telefone',
        submitted_leads: 'meus leads enviados',
        settings: 'configurações',
        switch: 'Mudar para marca/organização',
        beta_features: 'Recursos beta',
        gender: {
            singular: "gênero",
            male: "macho",
            female: "fêmea",
            other: "outra",
        },
        profile: {
            title: 'perfil',
            description: 'Gerencie as informações do seu perfil, altere sua senha e muito mais.',
        },
        remove: {
            label: 'remover conta',
            placeholder: 'Digite "delete" aqui e envie para remover a sua conta.',
            admin_placeholder: 'Digite "delete" aqui e envie para remover a sua conta.',
            safeword: 'excluir',
            description: 'Isso removerá sua conta e todos os dados associados.',
        },
        favorites: {
            title: 'favoritas',
            description: 'Seus eventos favoritos, escolas de dança etc.',
            no_favorites: 'você ainda não tem favoritos nesta categoria',
            plurals: {
                event: 'eventos',
                dancer: 'dançarinas',
                dj: 'DJs',
                media: 'mídia',
                brand: 'sapatos de dança, roupas, loja',
                school: 'escolas de dança',
                venue: 'Locais',
                club: "clube",
                teacher: "professora",
                show_performers_and_teams: "Mostrar artistas e equipes",
                performer: "artista",
                mc: "mc",
                latin_music: "música latina",
                event_organizer: "Organizador do evento",
                organization: 'organizações e marcas',
            },
        },
        likes: {
            title: 'gosta',
            description: 'Seus eventos gostos, escolas de dança etc.',
            no_likes: 'Você ainda não gosta nesta categoria',
            plurals: {
                event: 'eventos',
                dancer: 'Dancers',
                dj: 'DJs',
                media: 'Mídia (foto, vídeo, edição de vídeo)',
                brand: 'sapatos de dança, roupas, loja',
                school: 'escolas de dança',
                venue: 'Locais',
                club: "clube",
                teacher: "professora",
                show_performers_and_teams: "Mostrar artistas e equipes",
                performer: "artista",
                mc: "mc",
                latin_music: "música latina",
                event_organizer: "Organizador do evento",
                organization: 'organizações e marcas',
            },
        },
        verification: {
            phone: {
                description: "É necessária verificação do telefone para garantir a segurança e a autenticidade dos usuários que acessam o painel \'profissional\'.",
                not_verified: 'Seu número de telefone não foi verificado.',
                send_verification_text: 'Enviar texto de verificação',
                sent: 'Texto de verificação enviado',
                verified: 'Seu número de telefone está verificado.',
                verify: 'Verifique o número de telefone',
            },
        },

    },
    dashboard: {
        title: "painel",
        welcome: "Bem-vindo",
    },
    organizations: {
        organization_saved: 'organização salva',
        containing_emoji_error: 'Os emojis não são permitidos no nome. Utilize caracteres alfanuméricos ou caracteres especiais permitidos.',
        invalid_character_error: 'Existe um caractere inválido no nome. Utilize caracteres alfanuméricos ou caracteres especiais permitidos. \nCaracteres inválidos: ',
        overview: {
            filters: {
                option_labels: {
                    favorites: {
                        all: 'todos',
                    },
                    organization_type: {
                        all: 'todos',
                        dance_schools: 'escolas de dança',
                        organizers: 'organizadores',
                        artists: 'Professores e artistas',
                        disk_jockeys: 'DJs',
                    }
                }
            },
            no_results: {
                title: 'Nenhuma organização encontrada',
                subtitle: 'Nenhuma organização encontrada para os filtros selecionados.'
            },
        },
        transfers: {
            overview: {
                title: 'transferências',
                subtitle: 'Gerenciar a propriedade de suas organizações',
                incoming_transfers: 'transferências de entrada',
                outgoing_transfers: 'transferências de saída',
                request: 'solicitar',
                offer: 'oferecer',
                event: 'evento',
                organization: 'organização',
            },
            status: {
                approved: 'transferência aceita',
                pending: 'pendente',
                rejected: 'a transferência diminuiu'
            },
            create: {
                title: 'transferir propriedade',
                organization: 'organização',
                description: 'Transfira a propriedade da sua organização para outro usuário.',
                reason: 'razão',
                transfer_to: 'Transferência para (email)',
                transfer: 'transferir',
                warning: 'Assim que a transferência for aceita, a propriedade da organização será transferida para o novo proprietário.',
            }
        },
        remove: {
            label: 'Remover Organização',
            description: 'Excluir permanentemente esta organização e todos os dados associados.',
            success: 'Organização excluída com sucesso',
            error: 'Falha ao excluir organização'
        },
        transactions: {
            overview: {
                title: 'transações',
                subtitle: 'Gerencie as transações de suas organizações e marcas',
            }
        },
        create: 'criar organização',
        is_public_options: {
            private: 'privada',
            public: 'pública',
            private_warning: 'Sua organização não está visível online com esse status.'
        },
        offline_preview: 'Esta organização está offline e visível apenas como prévia.',
    },
    organization: {
        accepts_posts_on_behalf: 'Permitir que a LatinMap adicione os nossos eventos',
        accepts_posts_on_behalf_help: 'Quando a nossa marca está parada, a LatinMap pode adicionar eventos anunciados publicamente em nosso nome. Ficam claramente assinalados e pode editá-los ou removê-los quando quiser.',
        'on-behalf-of': 'em nome de',
        'on-behalf': {
            none: 'Selecione sua opção',
            me: 'Eu represento esta marca',
            other: 'Como representante da marca',
            noone: 'Como embaixador do LatinMap',
        },
        featured: {
            title: 'Escolas de dança em destaque',
            subtitle: 'Algumas das academias de dança com melhor classificação com cursos de dança agora disponíveis.',
        },
        my_favorites: {
            title: 'meus favoritos',
        },
        edit: {
            public_information: 'Informação',
            customers: 'clientes',
            events: 'eventos',
            tickets: 'ingressos',
            authorized_person: 'pessoas autorizadas',
        },
        organization_detail: {
            involved: 'envolvida',
            verification_status: {
                verified: 'verificada',
                not_verified: 'ainda não verificado',
            }
        },
        account: {
            title: "conta",
            description: "Gerencie as informações da sua conta para o painel profissional.",
            description_not_verified: "Verifique o número de telefone para usar o painel profissional.",
        },
        transfer: {
            title: 'transferir propriedade',
            description: 'Deseja solicitar a propriedade desta organização?',
            what: 'O que é oferecido?',
            submit: 'enviar solicitação',
            name: 'nome',
            location: 'localização',
            email: 'e-mail',
            reason: 'razão',
            organization: 'organização e marca',
            errors: {
                nameRequired: 'o nome é necessário.',
                emailRequired: 'O email é necessário.',
                reasonRequired: 'Razão é necessária.'
            },
            succesfully_sent: 'A solicitação de transferência foi enviada com sucesso.',
            error_occurred: 'Algo deu errado.',
            noOrganisation: 'Você ainda não tem nenhuma organização.'
        },
        title: "organização",
        is_public: 'é público',
        publicly_visible: 'publicamente visível',
        change_organization: "mudança de organização",
        create: "criar organização",
        name: "nome",
        name_without_dj: "Nome (sem 'dj')",
        dj_name_tooltip: "Introduza apenas o nome. O 'DJ' será adicionado automaticamente",
        email: "e-mail",
        phone: "número de telefone",
        phone_verification_token: "Token de verificação de telefone",
        country: "país",
        city: "cidade",
        street: "rua",
        street_number: "número da rua",
        postal_code: "código postal",
        type: "tipo",
        question: "Sua organização?",
        types: {
            event: 'Evento',
            dancer: "dançarina",
            latin_music: "música latina",
            performer: "artista",
            teacher: "professora",
            show_performers_and_teams: "Mostrar artistas e equipes",
            dj: "DJ",
            mc: "mc",
            media: "Mídia (foto, vídeo, edição de vídeo)",
            brand: "sapatos de dança, roupas, loja",
            event_organizer: "Organizador do evento",
            school: "escola de dança",
            live_music: "banda/música ao vivo",
            venue: "local",
        },
        short_description: "breve descrição",
        long_description: "longa descrição",
        photos: "fotos",
        dance_styles: "Estilos de dança",
        music_styles: "Estilos musicais",
        my_brands: "minhas marcas",
        my_brands_description: "Gerencie suas marcas",
        overview: {
            title: 'escolas de dança',
            subtitle: 'Encontre as melhores escolas de dança da sua área.',
            filters: {
                organization_name: 'Nome da organização',
                dance_styles: 'Estilos de dança',
                postal_code: 'código postal',
                nearby_range: 'Gama de sugestões de código postal nas proximidades',
                nearby: 'sugestões próximas',
                location: 'onde',
                favorites: 'favoritas',
                country_codes: 'Códigos do país',
                music_styles: 'Estilos musicais',
                ambassadors: 'embaixatrizes',
                slidertooltip: '<p> <strong> O controle deslizante de alcance ajusta os dígitos do código postal inserido para expandir a área de pesquisa. </strong> <p> Cada etapa aumenta o código postal por 100. </p><p> Por exemplo , em Etapa 1, o código postal é aumentado em 100 e, na etapa 10, é aumentado em 1000.',
            },
            organizers: {
                title: 'Organizers',
                subtitle: 'Encontre os melhores organizadores da sua área.',
            },
            artists: {
                title: 'Professores e artistas',
                subtitle: 'Encontre os melhores artistas da sua área.',
            },
            dance_schools: {
                title: 'escolas de dança',
                subtitle: 'Encontre as melhores escolas de dança da sua área.',
            },
            disk_jockeys: {
                title: 'DJs',
                subtitle: 'Encontre os melhores DJ’s da sua região. Desfrute dos melhores eventos e festivais.',
            },
            show_performers_and_teams: {
                title: 'Mostrar artistas e equipes',
                subtitle: 'Encontre os melhores artistas da sua área.',
            },
            teacher: {
                title: 'professoras',
                subtitle: 'Encontre os melhores professores da sua área.',
            },
            mcs: {
                title: "MC\'s",
                subtitle: 'Encontre os melhores MCs da sua área.',
            },
            live_music: {
                title: "bandas/música ao vivo",
                subtitle: 'Encontre as melhores bandas ao vivo e música da sua área.',
            },
            live_performer: {
                title: "artista ao vivo",
                subtitle: 'Encontre os melhores artistas ao vivo em sua área.',
            },
            performer: {
                title: "artista",
                subtitle:
                    "Encontre os melhores artistas ao vivo na sua área. Desfrute dos melhores eventos e festivais."
            },
            media: {
                title: "Mídia (foto, vídeo, edição de vídeo)",
                subtitle: 'Encontre os melhores fotógrafos e videógrafos em sua área.',
            },
            brand: {
                title: "sapatos de dança, roupas, loja",
                subtitle: 'Encontre os melhores sapatos de dança e roupas da sua área.',
            },
        },
        artists: {
            title: 'Professores e artistas',
        },
        teacher: {
            title: 'professoras',
        },
        performer: {
            title: 'artistas'
        },
        show_performers_and_teams: {
            title: 'Mostrar artistas e equipes',
        },
        dance_schools: {
            title: 'escolas de dança',
        },
        disk_jockeys: {
            title: 'DJs',
        },
        organizers: {
            title: 'organizadores',
        },
        manage_authorized_people: {
            title: 'Gerenciar pessoas autorizadas',
            description: 'Gerencie as pessoas autorizadas das organizações das quais você é proprietário. Pessoas autorizadas podem gerenciar sua organização e eventos.'
        },
        authorized_people: {
            title: 'Pessoas autorizadas',
            description: 'Gerencie as pessoas autorizadas de suas organizações. Pessoas autorizadas podem gerenciar sua organização e eventos.',
            create: 'Criar pessoa autorizada',
            edit: 'Editar pessoa autorizada',
            overview: 'Pessoas autorizadas',
            not_found: 'Nenhuma pessoa autorizada encontrada',
        },
        mcs: {
            title: "MC's",
        },
        live_music: {
            title: "bandas/música ao vivo",
        },
        live_performer: {
            title: "artistas ao vivo",
        },
        media: {
            title: "Mídia (foto, vídeo, edição de vídeo)",
        },
        brand: {
            title: "sapatos de dança, roupas, loja",
        },
        email_authorized: 'Digite um endereço de e -mail existente.',
    },
    ambassador: {
        profile: "perfil",
        my_brands: "minhas marcas",
        verification: {
            phone: {
                description: "É necessária verificação do telefone para garantir a segurança e a autenticidade dos usuários que acessam o painel \'embaixador\'."
            }
        }
    },
    brands: {
        create: "criar marca",
        brand_saved: "marca salva",
        change_brand: "mudar de marca",
        edit: {
            authorized_person: "pessoas autorizadas"
        },
        posted_by_ambassador_text: 'Esta marca foi criada por um embaixador do LatinMap, um membro da comunidade confiável que contribui para o conteúdo da plataforma.',
    },
    contact: {
        title: "contato",
        name: "nome",
        email: "e-mail",
        message: "mensagem",
        subject: "assunto",
        send: "enviar",
        success: "mensagem enviada",
        error: "Mensagem não pôde ser enviada",
    },
    ticketstore: {
        select_amount: 'Selecione o valor do ticket',
        your_information: 'suas informações',
        total: 'total',
        next: 'próxima',
        back: 'voltar',
        checkout: 'Confira',
        tickets_for: 'ingressos para',
        ticket_types: 'Tipos de ingressos',
        ticket: {
            starts_at: 'começa em',
            location: 'localização',
            name: 'nome',
            description: 'descrição',
            tickets_sold: 'ingressos vendidos',
            actions: 'ações',
            available: 'disponível',
            total_available: 'total disponível',
            price: 'preço',
            create: 'Crie tipo de ingresso',
            edit: 'Editar o tipo de ingresso',
            success: 'Seu tipo de ingresso foi enviado com sucesso.',
            remove_label: 'Remova o tipo de ticket',
            remove_description: 'Isso removerá o tipo de ticket e todos os dados associados.',
        },
    },
    events: {
        owned_by_organization: 'De propriedade da organização {organization_name}',
        select_category: "Selecione uma categoria",
        select_country: "Selecione um país",
        select_timezone: "Selecione um fuso horário",
        select_status: "selecione um status",
        select_currency: "Selecione uma moeda",
        select_brand_error: "Nenhuma marca selecionada",
        title: 'eventos',
        bring_online: 'trazer online',
        take_offline: 'tirar do ar',
        by: 'Eventos por {organization_name}',
        create_new: 'Crie um novo evento',
        event_saved: 'Evento salvo',
        event_published: 'Seu evento agora está ao vivo e visível na página de eventos.',
        error_saving: 'Evento de economia de erro',
        containing_emoji_error: 'Os emojis não são permitidos no nome. Utilize caracteres alfanuméricos ou caracteres especiais permitidos.',
        invalid_character_error: 'Existe um caractere inválido no nome. Utilize caracteres alfanuméricos ou caracteres especiais permitidos. \nCaracteres inválidos: ',
        duration_too_long: 'A duração deste evento é muito longa, o número máximo de dias que um evento pode levar é: ',
        error_updating_ticket_type: 'Ocorreu um erro ao salvar o tipo de ingresso.',
        ticket_type_updated: 'O tipo de ingresso foi atualizado com sucesso.',
        posted_by_ambassador: 'Postado por Latinmap embaixador',
        posted_by_ambassador_text: 'Este evento foi criado por um embaixador do LatinMap, um membro da comunidade confiável que contribui para o conteúdo da plataforma.',
        posted_on_behalf_text: 'A LatinMap adicionou este evento com base em informações publicamente disponíveis. O organizador ainda não atualizou estas informações.',
        posted_on_behalf_label: 'adicionado pela LatinMap',
        // LA-202: the public pill on the event page. Separate from the
        // line above, which is appended to a title in the organiser's own
        // list and reads as a note rather than a credit.
        posted_by_latinmap: 'Publicado pelo LatinMap',
        not_posted_by_ambassador: 'Verificado pelo organizador',
        participants: {
            create: {
                title: 'Criar participante para "{event_name}"',
                description: 'Crie um novo participante para o evento "{event_name}"',
                invite: 'Convide participante',
                role: 'papel',
            },
            role: {
                performer: 'artista',
                organizer: 'organizadora',
            },
            overview: {
                participants: 'participantes',
            }
        },
        statuses: {
            active: 'ativa',
            canceled: 'cancelada',
            changed: 'mudado',
            pending: 'pendente'
        },
        currencies: {
            none: 'Sem moeda',
            euro: 'Euro',
            dollar_american: 'Dólar Americano',
            pound_uk: 'Libra Esterlina',
            lira_turkish: 'Lira Turca',
            rupee_indian: 'Rupia indiana'
        },
        event_detail: {
            cta_block: {
                title: 'ingressos',
                subtitle: 'Existem ingressos disponíveis para este evento!',
                button: 'Obtenha seus ingressos agora'
            },
            organizer: {
                plural: 'organizadores',
                singular: 'organizadora',
                invariable: 'Organizador (s)',
            }
        },
        overview: {
            title: 'eventos',
            nearby_events: 'eventos próximos',
            subtitle: 'Mergulhe nas batidas rítmicas, movimentos emocionantes e fusão cultural de salsa, bachata e muito mais.',
            festival: {
                title: 'festivais de dança e congressos',
            },
            try_out: {
                title: 'Experimente, dia aberto, inicie curso(s)',
            },
            party_social: {
                title: 'Festas e Sociais',
            },
            no_results: {
                title: 'Nenhum evento encontrado',
                subtitle: 'Nenhum evento encontrado para os filtros selecionados.'
            },
            filters: {
                event_name: 'Nome do evento ou da organização',
                event_id: 'ID do evento',
                event_category: 'Tipo de evento',
                dance_styles: 'Estilos de dança',
                dance_style: 'estilo de dança',
                music_styles: 'Estilos musicais',
                music_style: 'estilo musical',
                ambassadors: 'embaixatrizes',
                status: 'status',
                user_name: 'usuária',
                user_type: 'tipo de usuário',
                organization: 'organização',
                organization_type: 'Tipo de organização',
                location: 'onde',
                date: 'quando',
                date_from: 'de',
                date_to: 'para',
                apply_filters: 'Aplicar filtros',
                clear_filters: 'filtros claros',
                country_codes: 'Códigos do país',
                city: 'cidade',
                favorites: 'favoritas',
                postal_code: 'código postal',
                nearby_range: 'Gama de sugestões de código postal nas proximidades',
                apply: 'aplicar',
                sliderinfo: 'incrementos de 100',
                slidertooltip: '<p> <strong> O controle deslizante de alcance ajusta os dígitos do código postal inserido para expandir a área de pesquisa. </strong> <p> Cada etapa aumenta o código postal por 100. </p> <p> Por exemplo , em Etapa 1, o código postal é aumentado em 100 e, na etapa 10, é aumentado em 1000.',
                option_labels: {
                    date_filter: {
                        upcoming: 'por vir',
                        this_week: 'essa semana',
                        next_week: 'próxima semana',
                        in_two_weeks: 'Em duas semanas +',
                        this_month: 'este mês',
                        specific_dates: 'datas específicas',
                        all: 'todos'
                    },
                    favorites: {
                        all: 'todos',
                        favorites: 'favoritas',
                        likes: 'mostre apenas meus eventos gostos',
                        favorites_likes: 'show gostou de eventos ou eventos de marcas favoritas',
                    },
                    organization_type: {
                        all: 'todos',
                        dance_schools: 'escolas de dança',
                        organizers: 'organizadores',
                        music_styles: 'Estilos musicais',
                        music_style: 'estilo musical',
                        artists: 'Professores e artistas',
                        disk_jockeys: 'DJs',
                    },
                    user_type: {
                        professional: 'profissional',
                        ambassador: 'embaixadora',
                        admin: 'admin',
                        superadmin: 'superadmin'
                    }
                }
            },
            workshop_bootcamp: {
                title: 'workshops e bootcamps',
            },
        },
        type: {
            festivals_and_congresses: 'festivais e congressos',
            try_out: 'Experimente, dia aberto, inicie curso(s)',
            live_music: 'bandas/música ao vivo',
            workshop_bootcamp: 'workshops e bootcamps',
        },
        categories: {
            festival: 'Festival/Congresso',
            workshop_bootcamp: 'workshop/bootcamp',
            workshop_bootcamp_party: 'festa com workshop/bootcamp',
            party_social: 'partido/social',
            competition: 'concorrência',
            performance_concert: 'Performance/Concerto',
            outdoor_event: 'Evento ao ar livre',
            dance_trip: 'viagem de dança',
            party_live_music: 'festa/música ao vivo',
            online_event: 'evento online',
            try_out: 'Experimente, dia aberto, inicie curso(s)',
            show: 'mostrar',
            marathon: 'maratona',
            weekender: 'Weekender',
            retreat: 'Retiro',
            other: 'outra',
        },
        create: 'Criar evento',
        edit: 'Evento de edição',
        remove: {
            label: 'Remova o evento',
            description: 'Isso removerá o evento e todos os dados associados.',
        },
        brand: 'marca/organização',
        name: 'nome',
        country: 'país',
        city: 'cidade',
        street: 'rua',
        street_number: 'número da rua',
        short_description: 'breve descrição',
        long_description: 'longa descrição',
        dance_styles: 'Estilos de dança',
        music_styles: 'Estilos musicais',
        photos: 'fotos',
        photos_preview_mode: 'As fotos são visíveis após economizar no modo de visualização',
        preview: 'mostrar',
        category: 'Tipo de evento',
        language: 'linguagem',
        location_type: {
            singular: 'Tipo de localização',
            online: 'virtual',
            offline: 'pessoalmente',
        },
        timezone: 'fuso horário',
        date: 'data',
        week: 'semana',
        start: 'começar',
        end: 'fim',
        location: 'localização',
        information: 'Informação',
        start_date: 'data de início',
        start_time: 'Hora de início',
        end_date: 'Data de término',
        end_time: 'Hora do final',
        ends_at: 'termina em',
        registration_opens_at: 'As inscrições são abertas em',
        registration_closes_at: 'As inscrições fecham em',
        is_public: 'Pronto para ir ao ar?',
        location_name: 'Nome do local',
        photos_required: 'Pelo menos uma foto é necessária.',
        tickets_sold: 'ingressos vendidos',
        actions: 'ações',
        participate: 'participar',
        verified: 'Brand Oficial Verificado',
        undercondition: 'ainda não confirmado',
        warning: 'Mudança importante - última atualização:',
        ticket:'ingressos disponíveis',
        cancelled: 'Cancelado - última atualização:',
        upcoming: 'próximos eventos',
        past: 'eventos anteriores',
        status: 'status',
        status_reason: 'Razão de status',
        entrance: 'preços dos bilhetes',
        entrance_tooltip: 'Aqui pode especificar o preço do bilhete. Introduza um número se o preço não se alterar, por exemplo: \'5\'. para uma gama de preços, pode especificar um intervalo, por exemplo, \'5-10\'. Utilize \'free\' se não houver preço de entrada.',
        currency: 'Moeda',
        currency_tooltip: 'Também é possível especificar a moeda. As moedas mais utilizadas são: euro (€), dólar norte-americano ($), libra esterlina (£), lira turca (₺) e rupia indiana (₹). Se não for selecionada nenhuma moeda, pode adicionar qualquer texto, como \'5-12 euros\'.',
        repeat: 'repete',
        djs: 'DJs',
        dj: 'DJ',
        artists: 'artistas',
        artist: 'artista',
        question: "Seu evento?",
        status_options: {
            active: 'ativa',
            canceled: 'cancelada',
            pending: 'ainda não confirmado',
            changed: 'mudança importante',
        },
        is_public_options: {
            draft: 'rascunho',
            private: 'privada',
            public: 'pública',
            draft_message: 'Salve seu evento como um rascunho.',
            private_message: 'Seu evento será visível apenas para usuários com acesso.',
            public_message: 'Publique seu evento para torná -lo visível na página de eventos.',
            private_warning: 'Seu evento não está visível online com esse status.'
        },
        legend: {
            title: 'lenda',
            verified: 'Brand Oficial Verificado',
            not_verified: 'Não é verificado pela organização: o organizador ainda não confirmou a atividade.',
            cancelled: 'cancelada',
            warning: 'mudança importante',
            posted_by: 'Postado por Latinmap embaixador',
            condition: 'ainda não confirmado',
            ticket:'ingressos disponíveis',
            duplicate_event_error: 'Um evento com este nome, data de início e data de término já existe',
            ticket_order: 'Ingressos disponíveis, compre-os aqui!'
        },
        ticket_types: 'Tipos de ingressos',
        potential_duplicates: 'Possíveis duplicatas',
        proceed_anyway: 'economize apesar da duplicata',
        duplicate_event_error: 'Um evento com este nome, data de início e data de término já existe',
        event_deleted: 'Evento excluído',
        error_deleting_event: 'Evento de exclusão de erros',
        featured: {
            title: 'Eventos em destaque na comunidade',
            subtitle: 'Descubra e faça seus ingressos para festivais de dança, concertos e viagens pelo melhor preço!',
            badge: 'Destaque',
            view: 'Ver evento',
            title_page: 'Alterar o preço global',
            featured_event: "Comprar evento em destaque",
            duration_type: "Tipo de duração",
            day: "dia",
            month: "mês",
            year: "ano",
            duration: "duração",
            price: "preço",
            calculate_price: "calcule o preço",
            proceed_to_payment: "prossiga para o pagamento",
            current_price: "Preço atual",
            no_price_found: "Nenhum preço encontrado para a duração selecionada",
            update_price: "Preço de atualização",
            setFeaturedEvents: "Definir evento em destaque",
            fetch_current_price: "buscar preço atual",
            update_global_event_price: "Atualizar o preço do evento global",
            price_per_day: 'Preço por dia',
            buy: 'Comprar evento em destaque',
            duration_label: 'Por quanto tempo você gostaria de apresentar o evento?',
            enter_duration: 'Selecionar duração',
            total_price: 'total',
            yes: "sim",
            no: "não",
            invalid_invoice: 'Algo deu errado, tente novamente',
            download_failed: 'Algo deu errado, tente novamente',
            setFeaturedEvent: 'Definir evento em destaque para:',
            setFeatured: 'Definir evento em destaque',
            featured_success: 'O evento foi apresentado com sucesso.',
            already_featured: 'Este evento já foi apresentado',
            featured_error: 'Algo deu errado',
            durationError: 'o valor não pode ser menor que 1'
        },
    },
    blocked_user:{
        create: 'Create blocked user',
        edit: 'Atualizar usuário bloqueado',

        blocked_email: 'Blocked email',
        blocked_phone_number: 'Número de telefone bloqueado',
        reason: 'razão',

        delete: {
            warning: {
                title: 'Exclua o bloqueio do usuário',
                body: 'tem certeza de que deseja excluir este bloco.'
            }
        }
    },
    carousel: {
        title: 'Descubra a dança latina - eventos, escolas, testes e muito mais perto de si!',
        subtitle: 'Descubra onde dançar, aprender e se conectar com a comunidade latina.',
        popular: 'Popular',
        search: {
            placeholder: 'Introduza uma palavra-chave ou cidade para explorar opções de dança latina...',
            button: 'DESCOBRIR',
        }
    },
    home: {
        // LA-179: the official Instagram strip that closes the homepage.
        instagram: {
            title: 'Ao vivo da pista',
            subtitle: 'O mais recente do nosso Instagram — a cena como ela é mesmo, semana após semana.',
            follow: 'Segue {handle}',
            post_alt: 'Uma publicação de {handle} no Instagram',
        },
        cta_block_1: {
            title: 'Você organiza eventos de dança?',
            subtitle:
                'Se você organiza festas, festivais, passeios, congressos, fins de semana, workshops, cursos intensivos e concertos de dança, temos algo para você. Promova seu evento, gerencie promotores e venda ingressos!',
            button: 'Inscreva-se agora'
        },
        cta_block_2: {
            title: 'Descubra Eventos Perto de Você',
            subtitle:
                'Descubra eventos e atividades em sua área. Explore e aproveite as experiências!',
            placeholder: 'Sua localização',
            input_button: 'Perto de mim',
            button: 'Encontrar eventos'
        },
        cta_block_3: {
            button: 'Criar Evento',
        },
        choose_and_live_experiences: 'Escolha e viva experiências',
        experiences: {
            festivals_congresses: "Festivais & Congressos",
            parties_socials: "Festas, Sociais",
            try_outs_start_courses: "Aulas experimentais & Cursos para iniciantes",
            dance_schools: "Escolas de dança",
            workshops_bootcamps: "Workshops, Bootcamps",
            dancewear_shoes: "Roupas & Sapatos de dança",
            teachers: "Professores",
            show_performers_teams: "Artistas & Equipas de show",
            djs: 'DJ\'s',
            live_music: "Bandas ao vivo",
            media_photo_video: "Mídia (Foto/Vídeo)",
            mcs: "MC's"
        },
        cta_journey: {
            title: 'Comece sua jornada no LatinMap',
            subtitle: 'Escolha como você quer experimentar o LatinMap',
            agenda: {
                title: 'Agenda Mundial',
                sub_header: 'Acesso livre',
                subtitle: 'Explore a cena global da dança latina',
                description: 'Navegue por festas, workshops, festivais, aulas experimentais e cursos iniciais - tudo em uma agenda',
                button: 'Ver Latin Agenda',
                footer: 'Nenhuma conta necessária'
            },
            member: {
                title: 'Torne-se Membro',
                sub_header: 'Conta gratuita',
                subtitle: 'Construa sua própria experiência LatinMap',
                description: 'Crie seu LatinMap pessoal e fique conectado à cena da dança latina — local e internacionalmente.',
                features: {
                    agenda: 'Agenda completa e atualizada de dança latina',
                    follow: 'Siga seus eventos, artistas e marcas favoritos',
                    save: 'Salve seus favoritos com um clique',
                    store: 'Armazene suas buscas e descobertas',
                    custom_agenda: 'Crie sua própria agenda personalizada',
                    explore: 'Explore novas cidades, estilos e cenas'
                },
                button: 'Criar conta grátis',
                footer: 'Grátis para participar – nunca perca um evento'
            },
            professional: {
                title: 'Torne-se Profissional',
                sub_header: 'Perfil profissional gratuito',
                subtitle: 'Para festivais, escolas de dança, professores, DJs, músicos e organizadores',
                description: 'Aumente sua visibilidade, gerencie seus eventos e alcance a comunidade latina internacional.',
                features: {
                    brand_page: 'Sua própria página de marca profissional',
                    publish: 'Publique e gerencie eventos facilmente',
                    invite: 'Convide membros da equipe para colaborar',
                    insights: 'Estatísticas e ferramentas de crescimento',
                    exposure: 'Exposição internacional no LatinMap'
                },
                button: 'Ativar conta Pro',
                footer: 'Requer primeiro uma conta de Membro'
            }
        },
    },
    dropzone: {
        drop_here: 'soltar arquivos aqui para fazer upload',
        files_required: "{count} obrigatório",
        max_filesize: "Tamanho máximo do arquivo: {max} mb"
    },
    general: {
        select_organization_please: "Por favor, selecione uma organização",
        no_organization_selected: "Nenhuma organização selecionada",
        all: 'todos',
        styles: 'estilos',
        important_information: 'informações importantes',
        starts_at: 'de',
        ends_at: 'para',
        socialmedia_links: 'links',
        share_with_your_friends: 'Compartilhe com seus amigos',
        link_copied: 'Link copiado para a área de transferência!',
        link_copy_failed: 'Falha ao copiar o link.',
        hosted_by: 'hospedado por',
        created_by: 'criado por',
        posted_by: 'Publicado por',
        created: 'criada',
        archive: 'arquivo',
        modified: 'modificada',
        score: 'pontuação',
        reset: 'reiniciar',
        unknown: 'desconhecida',
        submit: 'enviar',
        suggest: 'sugerir',
        other: 'outra',
        delete: 'excluir',
        copy_link: 'Link de cópia',
        back: 'voltar',
        show: 'mostrar',
        duplicate: 'duplicada',
        proceed: 'prosseguir',
        cancel: 'cancelar',
        accept: 'aceitar',
        reject: 'rejeitar',
        show_in_new_window: 'show em nova janela',
        checkout: 'Confira',
        external_link_warning: {
            title: 'Link externo',
            content: 'Você está prestes a sair deste site.',
            question: 'Deseja continuar para o seguinte URL?',
        },
        add: 'adicionar',
        date: 'data',
        search: {
            save_new: 'salve uma nova pesquisa',
            instructions: 'Salve sua pesquisa para usá -la novamente mais tarde.',
            name: 'nome',
            none_stored: 'Você ainda não tem pesquisas salvas.',
            stored: 'Pesquisas salvas',
            events: 'eventos',
            organizations: 'organizações',
            paginate: 'por página',
            page: 'página',
            view: 'visualizar',
            filters: 'filtros',
            delete: 'excluir',
            views: {
                grid: 'grade',
                list: 'lista',
                agenda: 'agenda',
                monthlist: 'Lista de meses',
            },
            filter_labels: {
                name: 'nome',
                location: 'localização',
                dance_styles: 'Estilos de dança',
                music_styles: 'Estilos musicais',
                event_categories: 'categorias de eventos',
                date_filter: 'data',
                favorites: 'favoritas',
                country_codes: 'Códigos do país',
                organization_type: 'Tipos de organização',
            },
        },
        socials: {
            facebook: 'Facebook',
            instagram: 'Instagram',
            site: 'site',
            linkedin: 'LinkedIn',
            youtube: 'YouTube',
            tiktok: 'Tiktok',
            reddit: 'Reddit',
            pinterest: 'Pinterest',
            twitter: 'x',
            spotify: 'Spotify',
            soundcloud: 'SoundCloud',
            facebook_event: 'Evento do Facebook',
            whatsapp: 'Whatsapp',
        },
        description: {
            title: 'descrição',
            show_more: 'mostre mais',
            show_less: 'mostre menos',
        },
        map: 'mapa',
        gmap_block: {
            title: 'mapa',
            location_name: 'Nome da localização'
        },
        spotify_block: {
            title: 'Spotify',
        },
        soundcloud_block: {
            title: 'SoundCloud',
        },
        paginate: {
            results: 'Resultados',
            filter: 'filtro',
            open_filter: 'Filtro aberto',
        },
        edit: 'editar',
        create: 'criar',
        expand: 'mais',
        more_info: 'Mais informações',
        collapse: 'menos',
        unique_impressions: 'impressões únicas',
        close: 'fechar',
        save_changes: 'salvar alterações',
        update_changes: 'salvar alterações',
        scrollright: 'Role para a direita para obter mais detalhes.'
    },
    header: {
        title: 'LatinMap',
        navigation: 'navegação',
        cta: 'Criar evento',
    },
    date: {
        from: 'de',
        to: 'para',
    },
    report: {
        event: 'Evento de relatório',
        organization: 'Organização do relatório',
        name: 'nome',
        location: 'localização',
        date: 'data',
        success: 'Seu relatório foi enviado com sucesso.',
        not_logged_in: 'conta necessária',
        tooltip: 'relatório',
        status: {
            warning: {
                title: 'Atualizar estado do relatório',
                body: 'Tem a certeza de que pretende alterar o estado deste relatório?'
            }
        },
        archive: {
            warning: {
                title: 'relatório de arquivo',
                body: 'Tem a certeza de que pretende apresentar este relatório? Isso não pode ser desfeito.'
            }
        }
    },
    form: {
        save: 'salvar',
        save_and_verify: 'salvar e verificar',
        too_many_requests: 'Você atingiu o limite da mensagem.' +
            'Aguarde alguns minutos antes de enviar outra solicitação',
    },
    form_subject: {
        general_inquiry: "Inquérito geral",
        technical_support: "Suporte técnico",
        issue_event_submission: "Edição de envio de eventos",
        issue_account_login: "conta de conta ou login",
        question_billing_payment: "Pergunta de cobrança ou pagamento",
        report_issue: "relatar um problema",
        suggest_feature: "sugestão de recursos",
        other: "outra"
    },
    api: {
        general: {
            validation_error: 'erro de validação',
            permission_denied: 'permissão negada',
            success: 'sucesso',
        },
        auth: {
            unauthorized: 'Você não está autorizado a acessar este recurso.',
            blocked: 'Sua conta foi bloqueada, você não poderá acessar nenhum recurso.',
            user_not_found: 'É necessário uma conta para usar essa funcionalidade, faça uma conta primeiro.',
            email_password_unknown: 'O endereço de email ou senha fornecido está incorreto.',
            email_unverified: 'Seu endereço de e -mail não foi verificado.',
            email_already_verified: 'Seu endereço de e -mail já foi verificado.',
            phone_already_verified: 'your phonenumber is already verified.',
            phone_already_used: 'Este número de telefone já está em uso',
            invalid_verification_link: 'O link de verificação fornecido é inválido.',
            email_verified_success: 'Seu endereço de e -mail foi verificado.',
            verification_email_sent: 'Um link de verificação foi enviado para o seu endereço de e -mail.',
            login_success: 'Você fez login com sucesso.',
            logout_success: 'Você fez logon com sucesso.',
            registration_success: 'Você se registrou com sucesso.',
            failed: 'Essas credenciais não correspondem aos nossos registros.',
            password: 'a senha fornecida está incorreta.',
            throttle: 'Muitas tentativas de login.',
            user_updated_success: 'Sua conta foi atualizada com sucesso.',
            old_password_incorrect: 'A senha antiga fornecida está incorreta.',
            password_changed_success: 'Sua senha foi alterada com sucesso.',
            user_deleted_success: 'Sua conta foi excluída com sucesso.',
            verification_text_sent: 'Um texto de verificação foi enviado para o seu número de telefone.',
            invite_invalid: 'O URL de convite usado é inválido.',
            too_many_requests: 'muitos pedidos.',
            day_limit_exceeded: 'Você excedeu a quantidade máxima de solicitações para essa funcionalidade hoje.'
        },
        organization: {
            created_success: 'A organização foi criada com sucesso.',
            authorized_person: {
                created: 'A pessoa autorizada foi criada com sucesso.',
                updated: 'A pessoa autorizada foi atualizada com sucesso.',
                removed: 'A pessoa autorizada foi removida com sucesso.',
                not_found: 'A pessoa autorizada não pôde ser encontrada.',
                already_exists: 'A pessoa autorizada já existe.',
                role: {
                    singular: 'papel',
                    invalid: 'A função fornecida é inválida.',
                    eventPublisher: 'editor de eventos',
                    eventCreator: 'Criador de eventos',
                    authorizedPerson: 'pessoa autorizada',
                }
            },
        },
        event: {
            created_success: 'O evento foi criado com sucesso.',
            deleted_success: 'O evento foi excluído com sucesso.',
        },
        report: {
            created_success: 'O relatório foi criado com sucesso.',
            invalid_type: 'O tipo de relatório fornecido é inválido.',
        },
        user: {
            updated_success: 'O usuário foi atualizado com sucesso.',
            search_filter: {
                created: 'criada',
            }
        },
        upload: {
            created_success: 'O upload foi criado com sucesso.',
            deleted_success: 'O upload foi excluído com sucesso.',
        },
        forms: {
            submitted_success: 'O formulário foi enviado com sucesso.',
        },
        passwords: {
            reset: 'Sua senha foi redefinida.',
            sent: 'Enviamos seu link de redefinição de senha por e -mail!',
            throttled: 'Por favor, espere antes de tentar novamente.',
            token: 'Este token de redefinição de senha é inválido.',
            user: 'Não podemos encontrar um usuário com esse endereço de e -mail.',
        },
        pagination: {
            previous: '&laquo; Anterior',
            next: 'Próximo &raquo;',
        },
        dance_style: {
            saved_success: 'O estilo de dança foi salvo.',
            deleted_success: 'O estilo de dança foi excluído com sucesso.',
            deleted_error: 'Erro excluindo o estilo de dança',
            not_found: 'O estilo de dança não pôde ser encontrado.',
            parent_not_found: 'O estilo de dança dos pais não pôde ser encontrado.',
            suggest_success: 'Sugestão de estilo de dança enviada.',
        },
        music_style: {
            saved_success: 'O estilo musical foi salvo.',
            deleted_success: 'O estilo musical foi excluído com sucesso.',
            not_found: 'O estilo musical não pôde ser encontrado.',
            parent_not_found: 'O estilo musical dos pais não pôde ser encontrado.',
            suggest_success: 'Sugestão de estilo musical enviado.',
        },
        invite: {
            sent: 'convite enviado',
            removed: 'convite removido',
            resend_success: 'Convite ressentido'
        },
        transfer_request: {
            already_owner: 'Você já é o proprietário desta organização.',
            organization_already_owns_event: 'A organização já possui o evento.',
        },
        transferlink: {
            removed: 'O transferlink foi removido.'
        },
        user_block: {
            create_success: 'O bloco de usuário foi criado com sucesso.',
            update_success: 'User block was successfully updated.',
            delete_success: 'O bloco de usuário foi excluído com sucesso.'
        },
    },
    favorites: {
        favorite: 'favorita',
        like: 'como',
        login_required: 'Você deve estar conectado para adicionar isso aos seus favoritos.',
    },
    likes: {
        login_required: 'Você deve estar conectado para adicionar isso aos seus gostos.',
    },
    validations: {
        validations: {
            doesnt_exist: {
                'owner id': 'Não foi possível encontrar o usuário para criar esta organização em nome de.'
            }
        },
        on_behalf_of: {
            required: 'O campo é necessário.',
        },
        required: 'Este campo é obrigatório.',
        phone: {
            required: 'o número de telefone é necessário.',
            regex: 'O número de telefone é inválido.',
            length: 'O número de telefone deve ter pelo menos 10 dígitos.',
        },
        'phone number': {
            required: 'o número de telefone é necessário.',
            regex: 'O número de telefone é inválido.',
            'not-unique': 'Este número de telefone já está em uso.',
        },
        number: {
            required: 'o número é necessário.',
            invalid: 'O número é inválido.'
        },
        email: {
            required: 'O endereço de e -mail é necessário.',
            invalid: 'O endereço de e -mail é inválido.',
            'not-unique': 'o endereço de e-mail não é único.'
        },
        name: {
            required: 'o nome é necessário.',
            max_length: 'O nome é muito longo.',
        },
        username: {
            required: 'O nome de usuário é necessário.',
            invalid: 'O nome de usuário é inválido.',
        },
        first_name: {
            required: 'O primeiro nome é necessário.',
        },
        last_name: {
            required: 'O sobrenome é necessário.',
        },
        gender: {
            required: 'O sexo é necessário'
        },
        city: {
            required: 'A cidade é necessária.',
        },
        street: {
            required: 'A rua é necessária.',
        },
        street_number: {
            required: 'O número da rua é necessário.',
        },
        country: {
            required: 'O país é necessário.',
        },
        brand: {
            required: 'A marca é necessária.'
        },
        short_description: {
            required: 'A breve descrição é necessária.',
        },
        long_description: {
            required: 'A longa descrição é necessária.',
        },
        description: {
            required: 'a descrição é necessária.',
        },
        type: {
            required: 'o tipo é necessário.',
        },
        message: {
            required: 'a mensagem é necessária.',
        },
        date_of_birth: {
            required: 'A data de nascimento é necessária.',
            regex: 'A data de nascimento é inválida.',
            age: 'Você deve ter pelo menos 18 anos.',
            old: 'Você deve ter no máximo 120 anos.'
        },
        date: {
            required: 'a data é necessária.',
            regex: 'A data é inválida.',
        },
        postal_code: {
            required: 'O código postal é necessário.',
            length: 'O código postal deve ter pelo menos 4 dígitos.',
        },
        entrance: {
            required: 'Os preços dos bilhetes são obrigatórios.',
        },
        repeat: {
            required: 'a repetição é necessária.',
        },
        password: {
            required: 'a senha é necessária.',
            regex: 'senha válida necessária.',
            confirmed: 'A confirmação de senha não corresponde.',
            mismatch: 'A senha não corresponde.',
        },
        conditions: {
            required: 'você deve aceitar os termos e condições.',
        },
        url: {
            required: 'o URL é necessário.',
            regex: 'O URL é inválido.',
        },
        event_category: {
            required: 'o tipo de evento é necessário.',
        },
        language_code: {
            required: 'o idioma é necessário.',
        },
        timezone: {
            required: 'o fuso horário é necessário.',
        },
        is_public: {
            required: 'a visibilidade é necessária.',
        },
        form_subject: {
            required: 'o assunto é necessário.',
        },
        starts_at: {
            required: 'A data de início é necessária.',
            regex: 'A data de início é inválida.',
        },
        start_date: {
            required: 'A data de início é necessária.',
            regex: 'A data de início é inválida.',
            after_end_date: "A data de início deve ser antes da data de término.",
        },
        start_time: {
            required: 'O horário de início é necessário.',
            regex: 'O tempo de início é inválido.',
        },
        end_date: {
            required: 'A data de término é necessária.',
            regex: 'A data final é inválida.',
            before_start_date: "A data final deve ser após a data de início.",
        },
        end_time: {
            required: 'O horário final é necessário.',
            regex: 'O horário final é inválido.',
        },
        ends_at: {
            required: 'A data de término é necessária.',
            regex: 'A data final é inválida.',
            before_start_date: "A data final deve ser após a data de início.",
        },
        registration_opens_at: {
            required: 'A data de início do registro é necessária.',
            regex: 'A data de início do registro é inválida.',
        },
        registration_closes_at: {
            required: 'A data final do registro é necessária.',
            regex: 'A data final do registro é inválida.',
        },
        location_type: {
            required: 'o tipo de localização é necessário.',
        },
        location_name: {
            required: 'o nome da localização é necessário.',
        },
        dance_styles: {
            required: 'Os estilos de dança são necessários.',
        },
        music_styles: {
            required: 'Os estilos musicais são necessários.',
        },
        photos: {
            required: 'É necessária pelo menos 1 fotografia.',
        },
        status: {
            required: 'o status é necessário.',
        },
        string: {
            required: '{fieldname} é necessário.',
            mismatch: '"{input}" não corresponde "{safeword}".',
        },
        role: {
            required: 'o papel é necessário.',
        },
        favorite: {
            required: 'O favorito é necessário.',
        },
        dance_style: {
            required: 'O estilo de dança é necessário.',
        },
        facebook: {
            required: 'O link do Facebook é necessário.',
            regex: 'Por favor, insira um link válido no Facebook.',
        },
        facebook_event: {
            required: 'O link do evento do Facebook é necessário.',
            regex: 'Insira um URL de evento do Facebook — deve apontar para facebook.com/events/{id}.',
        },
        instagram: {
            required: 'O link do Instagram é necessário.',
            regex: 'Por favor, insira um link válido do Instagram.',
        },
        website: {
            required: 'O link do site é necessário.',
            regex: 'Por favor, insira um link de site válido.',
        },
        twitter: {
            required: 'O link X é necessário.',
            regex: 'Por favor, insira um link x válido.',
        },
        linkedin: {
            required: 'O link do LinkedIn é necessário.',
            regex: 'Por favor, insira um link válido do LinkedIn.',
        },
        youtube: {
            required: 'O link do YouTube é necessário.',
            regex: 'Por favor, insira um link válido do YouTube.',
        },
        spotify: {
            required: 'O link do Spotify é necessário.',
            invalid: 'Por favor, insira um link do Spotify válido no formato correto.',
            regex: 'Por favor, insira um link do Spotify válido no formato correto.',
        },
        soundcloud: {
            required: 'O link do SoundCloud é necessário.',
            invalid: 'Por favor, insira um link do SoundCloud válido no formato correto.',
            regex: 'Por favor, insira um link do SoundCloud válido no formato correto.',
        },
        doesnt_exist: {
            email: 'O endereço de e -mail fornecido não existe.',
            user: 'o usuário fornecido não existe.',
        },
        djs: {
            required: 'Os DJs são necessários.',
        },
        artists: {
            required: 'Os artistas são necessários.',
        },
        reason: {
            required: 'o motivo é necessário.'
        },
        default: {
            doesnt_exist: {
                email: 'O endereço de e -mail fornecido não existe.',
                user: 'o usuário fornecido não existe.',
            }
        }
    },
    brand_activity: {
        by_brand: 'usuário da marca',
        by_admin: 'admin/scraping',
        export: 'Exportar CSV',
    },
    paginatable: {
        headers: {
            last_event_at: 'Última atividade de evento',
            last_event_by: 'Último evento por',
            has_upcoming: 'Próximos publicados',
            id: 'eu ia',
            brand_id: 'identidade da marca',
            title: 'título',
            slug: 'lesma',
            group: 'grupo',
            email: 'e-mail',
            phone: 'Phone number',
            name: 'nome',
            first_name: 'primeiro nome',
            last_name: 'sobrenome',
            role_name: 'papel',
            role: 'papel',
            report: 'relatório',
            created_at_formatted: 'criado em',
            status: 'status',
            actions: 'ações',
            type: 'tipo',
            to_user_email: 'Para e-mail',
            from_user_email: 'De e-mail',
            reason: 'razão',
            organization_name: 'Nome da organização',
            organization_created: 'organização criada',
            organization_updated: 'Organização pela última vez atualizada',
            confirmed_at: 'confirmado em',
            organization_role: 'papel',
            sub_dance_styles: 'Estilos de sub -dança',
            sub_music_styles: 'Estilos de sub -música',
            city: 'cidade',
            created_at: 'criada',
            updated_at: 'modificada',
            is_favorite: 'favorita',
            starts_at: 'começa em',
            tickets_sold: 'ingressos vendidos',
            price: 'preço',
            start_date: 'data de início',
            is_public: 'pública',
            available_tickets: 'ingressos disponíveis',
            user_id: 'ID do usuário',
            transferable_type: 'tipo',
            content_name: 'título',
            paynl_transaction_id: 'Transação Paynl',
            date: 'data de compra',
            amount: 'montante total',
            tax_amount: 'imposto',
            currency: 'moeda',
            description: 'descrição',
            valid_from: 'começar',
            valid_until: 'termo',
            items: 'Unid',
            total: 'total',
            featured: 'apresentou',
            created_by: 'usuária',
            location_type: 'Tipo de localização',
            category_id: 'Category',
            organization_category_id: 'categoria',
            country_code: 'Código do país',
            location: 'localização',
            info: 'Informações do usuário',
            owner: 'representando',
            adres: 'endereço',
            export_created: 'exportação criada',
            image_path: "Caminho da imagem",
            order_by: "Ordenar por",
            visibility: "Visibilidade",
            image_alt: "Texto alternativo da imagem",
            image_title: "Título da imagem",
            image: "Imagem",
            public_status: "Status público",
            country: 'País',
            activity: 'Atividade',
        },
        search: 'pesquisa',
        no_records: 'Nenhum resultado encontrado',
    },
    pages: {
        related: 'páginas relacionadas',
        contact: {
            title: 'Entre em contato com o LatinMap',
            body: 'Para perguntas relacionadas a eventos, entre em contato com a organização que publicou o evento.'
        },
        'how-it-works': {
            title: 'como funciona',
            body: '<p> Vendas on -line de ingressos via latinmap.com </p> <p> Oferecemos às organizações a possibilidade de vendas de ingressos on -line.'
        },
        'goods-and-services': {
            title: 'bens e serviços',
            body: '<p> latinmap.com: Descubra e experimente o mundo da dança latina </p> <p> Bem -vindo ao latinmap.com, o destino em que você ganha acesso sem esforço aos eventos e experiências mais interessantes do mundo da dança latina .'
        },
        'terms-and-conditions': {
            title: 'termos e Condições',
            body: '<p>20230529 Termos e Condições de Venda de Bilhetes</p><p>1. definições</p><p>Os termos aqui definidos com letra inicial maiúscula têm o seguinte significado nos presentes Termos e Condições:<br/>a. Termos e Condições: estas condições gerais de venda de bilhetes da Fundação LatinMap.com<br/>b. Evento: o evento organizado, enquanto evento de natureza musical, cultural, desportiva e/ou recreativa, para o qual a Fundação LatinMap.com vende bilhetes<br/>c. Organizador do Evento: a pessoa singular ou coletiva que produz ou organiza um Evento e é responsável pelo mesmo<br/>d. Cliente: a pessoa singular ou coletiva que celebra um acordo com a Fundação LatinMap.com relativo a um Evento, ou a quem a Fundação LatinMap.com faz uma oferta para o fazer<br/>e. Acordo: o acordo entre a Fundação LatinMap.com e o Cliente para a aquisição de Bilhetes para Eventos<br/>f. Bilhete: documento que serve de bilhete de admissão para um Evento, incluindo Bilhetes eletrónicos</p><p>2. Aplicabilidade</p><p>a. Estes Termos e Condições aplicam-se a todas as ofertas, encomendas, relações legais e acordos nos quais a Fundação LatinMap.com entrega produtos ou serviços de qualquer tipo ao Cliente, mesmo que esses produtos ou serviços não estejam (mais) descritos nestes Termos e Condições.<br/>b. A Fundação LatinMap.com rejeita expressamente a aplicabilidade de quaisquer outras condições do Cliente.<br/>c. As partes só podem concordar com desvios dos Termos e Condições por escrito. A Fundação LatinMap.com tem o direito de alterar os Termos e Condições e declarar termos e condições gerais alterados aplicáveis ​​aos Contratos. Os termos e condições gerais alterados podem ser consultados no site da Fundação LatinMap.com. d. O Contrato está sujeito aos termos e condições gerais do Organizador do Evento. Caso o Cliente ainda não esteja na sua posse, o Organizador do Evento enviará os termos e condições gerais do Organizador do Evento ao Cliente, mediante solicitação.</p><p>3. Formação de acordo</p><p>a. Salvo acordo em contrário por escrito, todas as ofertas, incluindo anúncios e listas de preços mencionados no site da Fundação LatinMap.com, são sem compromisso. b. Ao oferecer e vender bilhetes, a Fundação LatinMap.com atua como mediadora na formação do Contrato entre o Comprador e o Organizador do Evento. A Fundação LatinMap.com não é parte no Contrato que é celebrado pela compra de um Bilhete. O Contrato é concluído após o Cliente adquirir um ou mais Bilhetes através da Fundação LatinMap.com. A Fundação LatinMap.com fornece os bilhetes em nome do Organizador do Evento.<br/>c. Antes de confirmar a sua reserva, o Cliente deverá sempre verificar se os Bilhetes corretos foram reservados. Ao efetuar a reserva, o Cliente deverá utilizar sempre um endereço (de e-mail) correto. Se o Cliente optar por receber os Bilhetes por via eletrónica, o risco de perda, roubo ou utilização indevida do Bilhete será do Cliente a partir do momento em que os Bilhetes lhe chegarem. Caso existam dúvidas sobre a exatidão dos dados introduzidos pelo Cliente aquando do pedido, a Fundação LatinMap.com poderá contactar o Cliente utilizando os dados introduzidos pelo Cliente. Se a Fundação LatinMap.com não conseguir contactar o Cliente e, por conseguinte, não conseguir verificar os dados, a Fundação LatinMap.com poderá cancelar a reserva e vender os Bilhetes a outro Cliente. Se a Fundação LatinMap.com duvidar da exatidão ou validade dos dados introduzidos pelo Cliente no momento da encomenda ou do método de pagamento utilizado pelo Cliente, tem o direito de cancelar a reserva do Cliente e vender os Bilhetes a outro Cliente. A Fundação LatinMap.com esforçar-se-á por informar o Cliente nesse caso. Todo o Contrato é celebrado sob a condição suspensiva de disponibilidade suficiente dos respetivos produtos ou serviços.<br/>d. A Fundação LatinMap.com e/ou o Organizador do Evento reservam-se o direito de definir um número máximo de bilhetes que podem ser reservados/comprados. Se este máximo for excedido pelo Cliente, a Fundação LatinMap.com e/ou o Organizador do Evento têm o direito de anular a reserva dos Bilhetes acima do número máximo ou de invalidar os Bilhetes em questão.<br/>e. Os bilhetes não podem ser devolvidos. O disposto no artigo 6:230p sub e BW aplica-se aos bilhetes.</p><p>4. Preços e Pagamento</p><p>a. A Fundação LatinMap.com vende bilhetes em nome dos organizadores do evento, que determinam o preço e o número de lugares disponíveis. As informações sobre preço e disponibilidade são fornecidas sem compromisso e estão sujeitas a alterações.<br/>b. O Cliente paga os produtos ou serviços encomendados através do site, o preço mencionado no Contrato. O pagamento é feito da forma indicada no site da Fundação LatinMap.com. Condições adicionais (pagamento/encomenda) podem ser aplicadas ao pedido.</p><p>c. Todos os preços da Fundação LatinMap.com mencionados no site são em euros, incluindo IVA, salvo indicação expressa em contrário.<br/>d. A Fundação LatinMap.com cobra taxas de serviço por cada encomenda. Além disso, a Fundação LatinMap.com cobra comissões de gestão calculadas com base no valor total da transação.</p><p>e. Caso o Cliente não pague os valores devidos atempadamente, ficará sujeito, sem necessidade de qualquer exigência ou aviso de incumprimento, ao pagamento dos juros legais sobre o valor em dívida. Caso o Cliente permaneça negligente na liquidação da reclamação após uma reclamação ou notificação de incumprimento, a Fundação LatinMap.com poderá entregar a reclamação, caso em que o Cliente será também obrigado a reembolsar todos os custos judiciais e extrajudiciais, incluindo os custos calculados por especialistas externos, para além dos custos legalmente estabelecidos.</p><p>5. Tempos de entrega</p><p>a. Os bilhetes são enviados para a morada (de e-mail) fornecida pelo Cliente no momento da encomenda. A Fundação LatinMap.com continuará a considerar o endereço (de e-mail) fornecido pelo Cliente como correto até que o Cliente notifique a Fundação LatinMap.com sobre um novo endereço (de e-mail). b. Os prazos de entrega estabelecidos pela Fundação LatinMap.com nunca serão considerados como um prazo rigoroso, a menos que expressamente acordado de outra forma. Em caso de entrega fora do prazo, a Fundação LatinMap.com deverá receber uma notificação escrita de incumprimento.</p><p>c. Exceder qualquer prazo de entrega não dá direito ao Cliente a compensação nem ao direito de cancelar o pedido ou rescindir o Contrato, a menos que o prazo de entrega tenha sido excedido a tal ponto que não seja razoável esperar que o Cliente mantenha o Contrato.</p><p>d. Com exceção da opção de encomendar bilhetes eletrónicos, as vendas de bilhetes através do site e do centro de atendimento serão interrompidas 8 dias antes da data do evento para dar à Fundação LatinMap.com a oportunidade de ainda enviar os bilhetes por correio.</p><p> 6. Eventos cancelados e reagendados </p><p> a. É da responsabilidade do Cliente verificar se um Evento foi cancelado ou reagendado e qual será o novo horário ou local. Embora a Stichting LatinMap.com tente notificar o Cliente sobre o cancelamento após receber as informações necessárias do Organizador do Evento, a Stichting LatinMap.com não pode garantir que o Cliente será notificado sobre o cancelamento antes da data do Evento. </p><p> b. Stichting LatinMap.com não se responsabiliza por quaisquer custos incorridos.<br/>c. Os bilhetes para eventos remarcados geralmente permanecem válidos para o evento de substituição. Para mais informações sobre este assunto, o Cliente pode contactar o Stichting LatinMap.com através do nosso endereço de e-mail: mail(at)LatinMap.com. Se um Evento for transferido para outro local ou data, o Organizador do Evento poderá impor condições ao reembolso do preço do bilhete.<br/>d. Se um Evento for cancelado ou reagendado, o Cliente poderá devolver os Bilhetes para este Evento de acordo com o acordo determinado pelo Organizador do Evento. Para as condições relevantes, remetemos para os Termos e Condições Gerais do organizador do evento. Se o Organizador do Evento solicitar à Stichting LatinMap.com que reembolse o preço do bilhete ao Cliente, a Stichting LatinMap.com fá-lo-á após receber os fundos relevantes do Organizador do Evento. As taxas de serviço e de administração não são reembolsadas. </p><p> 7. Ingressos </p><p> a. Os bilhetes distribuídos pela Stichting LatinMap.com permanecem propriedade do Organizador do Evento. O Cliente não está autorizado a revender um Bilhete se tal violar a lei. Além disso, um Organizador de Eventos pode proibir a revenda ou a utilização comercial de um Bilhete. O Cliente deverá verificar isso nos termos e condições gerais do organizador, que são mencionados no Bilhete (e durante o processo de encomenda). Em caso de (tentativa de) revenda ou utilização comercial em violação da lei ou das condições do Organizador do Evento, o Organizador do Evento tem o direito de invalidar o Bilhete relevante e/ou aplicar uma multa ao Cliente. Aos titulares de passes de acesso inválidos será negado o acesso ao Evento, sem direito a qualquer indemnização.<br/>b. Após a receção, o Cliente deverá conferir os Bilhetes, pois nem sempre é possível corrigir erros. Após a compra, os bilhetes não poderão ser trocados ou reembolsados.<br/>c. Se o bilhete do cliente estiver tão danificado que a sua autenticidade já não possa ser verificada, o cliente pode contactar o serviço de apoio ao cliente online.<br/>d. Pedidos especiais, como a reserva de lugares para cadeiras de rodas, devem ser comunicados de forma atempada e explícita. Stichting LatinMap.com não pode garantir que pedidos especiais possam ser atendidos. Para mais informações sobre este assunto, o Cliente pode contactar a Stichting LatinMap.com através do nosso endereço de e-mail: mail(at)LatinMap.com </p><p> 8. Direitos de Propriedade Intelectual e Industrial </p><p> a. Os direitos de propriedade industrial e intelectual sobre o Bilhete Stichting LatinMap.com pertencem à Stichting LatinMap.com ou ao seu licenciador. O Cliente deverá abster-se de quaisquer ações que possam infringir os direitos ou outros interesses da Stichting LatinMap.com ou do seu licenciante.<br/>b. O Cliente não está autorizado a remover ou alterar qualquer indicação de direitos de autor, marcas registadas, nomes comerciais ou outros direitos de propriedade intelectual ou industrial do Bilhete, nem a fazer quaisquer alterações na forma ou em qualquer outra característica do Bilhete.<br/>c. O Cliente está proibido de falsificar, duplicar ou reproduzir o Bilhete de qualquer forma.<br/>d. O Contrato não se estende à transferência de qualquer direito de propriedade intelectual da Stichting LatinMap.com para o Cliente. </p><p> 9. Privacidade </p><p> a. Os dados fornecidos pelo Cliente na compra dos bilhetes serão utilizados exclusivamente pela Stichting LatinMap.com para melhorar os seus serviços.<br/>b. Os dados fornecidos pelo Cliente no momento da compra dos bilhetes nunca serão disponibilizados a terceiros. </p><p> c. Os dados fornecidos pelo Cliente no momento da compra dos bilhetes ficarão à disposição da Organização vendedora. É possível que a organização utilize os dados para enviar correspondência.<br/>d. Esperamos que os nossos clientes tratem estas informações com cuidado. Caso tal não aconteça, gostaríamos de saber e informaremos o cliente em questão e, se considerarmos necessário, excluiremos o cliente das vendas de bilhetes online. </p><p> e. Nota: não nos responsabilizamos pela política de privacidade dos nossos clientes. </p><p> 10. Responsabilidade </p><p> a. A Stichting LatinMap.com não pode ser considerada a organizadora (Organizadora do Evento) do Evento e não é responsável nem garante a qualidade (artística) e o conteúdo do Evento e o curso dos eventos dentro ou em redor do Evento, e não aceita qualquer responsabilidade com base nisso. </p><p> b. Exceto no que respeita a outras disposições de responsabilidade nestes Termos e Condições Gerais, a responsabilidade total da Stichting LatinMap.com devido a falha atribuível na execução, ou devido a um ato ilícito, está limitada à compensação por danos diretos até ao montante que foi ou possa ser cobrado ao Cliente pelos Bilhetes, a menos que o dano seja o resultado de intenção e/ou negligência grave de </p><p> Stichting LatinMap.com ou os seus subordinados.<br/> c. A responsabilidade da Stichting LatinMap.com devido a uma falha atribuível no cumprimento de um contrato apenas surge em todos os casos se o Cliente declarar pronta e adequadamente a Stichting LatinMap.com em incumprimento por escrito, definindo um prazo razoável para a remediação da falha, e a Stichting LatinMap.com também após esse prazo continuar a falhar atribuivelmente no cumprimento das suas obrigações. O aviso de incumprimento deve conter uma descrição da falha tão completa e detalhada quanto possível, para que a Stichting LatinMap.com possa responder adequadamente.<br/> d. O Cliente indemnizará a Stichting LatinMap.com contra todas as reclamações de terceiros relacionadas com a falha ou o cumprimento insuficiente por parte do Cliente de qualquer obrigação para com a Stichting LatinMap.com, seja ou não decorrente dos Termos e Condições Gerais.<br/> e. Uma condição para a existência de qualquer direito a indemnização é sempre que o Cliente comunique o dano à Stichting LatinMap.com por escrito o mais rapidamente possível após a sua ocorrência. e. A Stichting LatinMap.com nunca poderá ser responsabilizada por qualquer tipo de dano ou perda do Bilhete. Em caso de perda ou roubo, o Cliente não poderá solicitar um bilhete de substituição ou o reembolso de quaisquer fundos. A Stichting LatinMap.com também não se responsabiliza por atrasos ou pela não entrega ou entrega incorreta dos Bilhetes, se o atraso, a não entrega ou a entrega incorreta não puderem ser atribuídos à Stichting LatinMap.com.<br/> g. A Stichting LatinMap.com não se responsabiliza por bilhetes obtidos de terceiros pelo Cliente. O Stichting LatinMap.com também não pode garantir a sua autenticidade.<br/> h. A Stichting LatinMap.com não poderá, de forma alguma, ser responsabilizada por quaisquer danos sofridos pelo titular deste bilhete devido a ações ou omissões de terceiros. </p><p> 11. Força Maior </p><p> a. Entende-se por motivo de força maior qualquer falha que não possa ser imputada à Stichting LatinMap.com, pois não é devida a sua culpa e nem por lei, ato legal ou de acordo com as normas geralmente aceites é da sua responsabilidade.<br/> b. Sem prejuízo dos seus outros direitos, a Stichting LatinMap.com tem o direito de suspender a execução do pedido do Cliente em caso de força maior, notificando o Cliente por escrito, e sem que a Stichting LatinMap.com seja obrigada a qualquer compensação, a menos que tal seja inaceitável de acordo com os padrões de razoabilidade e justiça nas circunstâncias dadas. </p><p> 12. Lei aplicável e tribunal competente </p><p> a. Todos os acordos com a Stichting LatinMap.com são regidos pela lei holandesa. </p><p> 13. Diversas </p><p> a. Os clientes que chegarem atrasados ​​ao Evento serão admitidos - na medida do possível - em momentos adequados no Evento. No entanto, a entrada não pode ser garantida.<br/> b. Quando estes Termos e Condições Gerais obrigarem a Stichting LatinMap.com a fazer uma comunicação por escrito, a Stichting LatinMap.com terá o direito de fazer essa comunicação por via eletrónica, como, mas não se limitando a, uma mensagem de correio eletrónico ou fax.<br/> c. Erros evidentes e erros tipográficos no website da Stichting LatinMap.com ou nas cotações, confirmações de encomendas, bilhetes e/ou outros documentos não vinculam a Stichting LatinMap.com. e. Em caso de desacordo entre a Stichting LatinMap.com e o Cliente relativamente à tradução e/ou interpretação dos Termos e Condições Gerais, a versão holandesa será decisiva.<br/> e. Se uma ou mais disposições destes Termos e Condições Gerais ou qualquer outro acordo com a Stichting LatinMap.com entrarem em conflito com qualquer exigência legal aplicável, a disposição relevante será anulada e será substituída por uma nova disposição comparável legalmente permitida a ser determinada pela Stichting LatinMap.com. </p>'
        },
        'privacy-policy': {
            title: 'política de Privacidade',
            body: '<p> Política de privacidade para latinmap.com: Descubra e experimente o mundo da dança latina <br> Última atualização: 23-05-2023 <br> Obrigado por visitar o latinmap.com, o destino para descobrir e experimentar o mundo da dança latina.'
        },
        about: {
            'about-latin-scene': {
                title: "sobre cena latina",
                body: "A cena de dança latina é uma comunidade vibrante e diversificada que celebra a rica herança cultural da América Latina através da música, dança e arte."
            },
            salsa: {
                title: "salsa",
                body: "Salsa é uma forma popular de dança social que se originou no Caribe."
            },
            bachata: {
                title: "Bachata",
                body: "Bachata é um gênero de música latino -americana que se originou na República Dominicana na primeira metade do século XX, com elementos musicais europeus, indígenas e africanos."
            },
            zouk: {
                title: "Zouk",
                body: "Zouk é um estilo de batida de carnaval de salto rápido de música rítmica, originária das ilhas do Caribe de Guadalupe e Martinique, popularizada pelas Antilhas francesas Kassav \'nos anos 80."
            },
            kizomba: {
                title: "Kizomba",
                body: "Kizomba é um gênero musical e estilo de dança originário de Angola no final da década de 1970 e início dos anos 80."
            },
            cuban: {
                title: "cubana",
                body: "A música e a dança cubana estão profundamente enraizadas no diverso patrimônio cultural da ilha, misturando influências africanas, espanholas e indígenas."
            },
        },
        'help-center-faq': {
            title: 'Ajuda e perguntas frequentes',
        },
        'cookie-policy': {
            title: 'Política de Cookies',
        },
        'create-an-event': {
            title: 'Como criar um evento',
        },
        'create-an-brand-or-an-organization': {
            title: 'Como criar uma marca',
        },
        'become-an-ambassador': {
            title: 'Torne -se um embaixador',
        },
        'promote-your-event': {
            title: 'Como promover seu evento',
        },
        'professional-account-verification': {
            title: 'Verificação de conta profissional'
        },
        'about-us': {
            title: 'Sobre nós',
        },
    },
    email: {
        'not-unique': 'O email já foi recebido.',
    },
    leads: {
        title: 'Enviar Lead',
        description_p1: 'Você é usuário do LatinMap e encontrou uma escola de dança, organização ou evento que ainda não está listado? Envie aqui — sua contribuição nos ajuda a manter a plataforma completa, precisa e valiosa para dançarinos em todo o mundo.',
        description_p2: 'Você é um organizador e quer ser listado no LatinMap? Crie uma Conta Pro e adicione suas atividades à plataforma gratuitamente!',
        description_p3: 'Obrigado por nos ajudar a expandir o LatinMap, a plataforma que conecta a comunidade global de dança.',
        plural: 'pistas',
        type: {
            event: 'evento',
            organization: 'organização',
            label: 'tipo',
        },
        name: 'nome',
        address: 'endereço',
        country: 'país',
        city: 'cidade',
        street: 'rua',
        street_number: 'número da rua',
        dance_styles: 'Estilos de dança',
        music_styles: 'Estilos musicais',
        photos: 'fotos',
        category: 'Tipo de evento',
        location_name: 'Nome do local',
        location_type: {
            singular: 'Tipo de localização',
            online: 'virtual',
            offline: 'pessoalmente',
        },
        timezone: 'fuso horário',
        date: 'data',
        not_posted_by_ambassador: 'Verificado pelo organizador',
        undercondition: 'sob condição',
        warning: 'mudança importante',
        cancelled: 'cancelada',
        posted_by_ambassador: 'Postado por Latinmap embaixador',
        upcoming: 'próximos eventos',
        status_options: {
            active: 'ativa',
            canceled: 'cancelada',
            pending: 'ainda não confirmado',
            changed: 'mudança importante',
            submitted: 'enviada',
            under_review: 'em revisão',
            implemented: 'implementada',
            declined: 'recusou',
        },
        submit: 'enviar',
        success: 'O lead foi enviado.',
        filter_type: 'filtre por tipo',
        view: 'liderar',
        confirm_delete: 'excluir chumbo',
        delete_confirmation: 'tem certeza de que deseja excluir esse lead?',
        deleted_successfully: 'O líder foi excluído com sucesso.',
        error_loading: 'Erro de carregamento de leads',
        status_updated: 'O status do principal foi atualizado.',
        error_status: 'Erro atualizando o status do lead',
    },
    search: {
        allOragnisations: 'Ver todas as escolas de dança',
        allEvents: 'Veja todos os eventos',
        searchresult: 'Resultados da pesquisa',
        type: 'Tipo',
        title: 'título',
        city: 'cidade',
        country: 'país',
        address: 'endereço',
        startdate: 'data de início',
        favorite: 'favorita'
    },
    components: {
        picture_input: {
            drag: "Carregue o avatar",
            remove: 'Exclua avatar',
            change_avatar: 'Alterar avatar'
        },
        pictureInput: {
            drag: "Clique aqui para fazer upload da imagem",
            change: "Alterar",
            remove: "Remover",
            upload: "Fazer upload",
            tap: "Toque para fazer upload",
            select: "Selecionar um arquivo",
            selected: "Selecionado",
            fileSize: "Tamanho do arquivo",
            fileType: "Tipo de arquivo",
            aspect: "Proporção"
        },
    },
    passion: {
        title: "Sinta o Ritmo, Junte-se ao Movimento",
        subtitle: "Descubra o vibrante mundo da dança latina. Conecte-se com dançarinos, encontre eventos perto de você e deixe a música tocar sua alma.",
    },
    payment: {
        received: "pagamento recebido",
        thank_you: "Obrigado pela sua compra!",
        download_ticket: "Download de ingressos (s)",
        download_button: "Download de ingressos (s)",
        email_check: "Verifique sua caixa de entrada, incluindo a pasta de spam, para obter um email do nosso sistema de ingressos.",
        failed: "pagamento pendente",
        failed_message: "Infelizmente, encontramos um problema processando seu pagamento.",
        download_invoice: "Baixe a fatura",
        download_invoice_button: "Baixe a fatura",
        invoice_check: "Por favor, verifique sua caixa de entrada para obter sua fatura.",
        thank_you_for_purchase: "Obrigado por comprar o evento em destaque!",
    },
    financial_center: {
        financial_dashboard: 'meu painel financeiro',
        title: "Centro Financeiro",
        description: "Gerencie suas transações, pagamentos, promoções e recursos premium.",
        overview: "visão geral",
        transactions: "transações",
        payoutsettings: "Configurações de pagamento",
        featured_events: "Eventos em destaque",
        ticketsales: "Vendas de ingressos",
        premium: "Contas premium",
    },
    inputfield: {
        select_here: 'Selecione aqui',
    },
    tooltip: {
        edit: 'editar',
        delete: 'excluir',
        view: 'visualizar',
        hide: 'esconder',
        under_construction: 'em construção',
    },
    // LA-157: where someone stops the automated emails LatinMap sends.
    email_preferences: {
        error: "Algo correu mal. Tenta novamente daqui a pouco.",
        confirm: {
            title: "Deixar de receber estes e-mails?",
            body: "Recebes estes e-mails automáticos em {email}.",
            note: "As mensagens sobre a tua conta, como repor a palavra-passe, continuam a ser enviadas.",
            button: "Parar estes e-mails",
        },
        done: {
            title: "Já não vais receber nada",
            body: "Não enviaremos mais e-mails automáticos para {email}.",
            undo: "Voltar a receber",
        },
        unknown: {
            title: "Este link já não funciona",
            body: "O link não é válido. Usa o link de um e-mail mais recente.",
        },
    },
    // LA-194: the public page an organiser reaches through a submission link.
    submit_event: {
        eyebrow: 'Enviar um evento',
        title: 'Envia o teu evento para o LatinMap',
        title_brand: 'Enviar um evento para {brand}',
        lede: 'Preenche o que souberes. Nós preparamos e publicamos após uma verificação rápida.',
        loading: 'Um momento…',
        notes: {
            no_account: 'Não precisas de conta — este link chega',
            checked: 'Verificamos cada evento antes de publicar',
            reply: 'Se algo não estiver claro, escrevemos-te',
        },
        sections: {
            event: 'O evento',
            where: 'Onde',
            details: 'Detalhes',
            you: 'Sobre ti',
        },
        fields: {
            name: 'Nome do evento',
            organizer_name: 'Nome do organizador / marca',
            organizer_url: 'Site ou redes sociais do organizador',
            start_date: 'Data',
            start_time: 'Hora de início',
            end_date: 'Data de fim',
            end_time: 'Hora de fim',
            dance_styles: 'Estilos de dança',
            event_category: "Tipo de evento",
            event_category_placeholder: "Escolhe um tipo de evento",
            location_name: 'Local',
            city: 'Cidade',
            country: 'País',
            country_placeholder: 'Escolhe um país',
            short_description: 'Descrição breve',
            description: 'Descrição completa',
            link: 'Link para mais informação ou bilhetes',
            photo: "Foto",
            photo_remove: "Remover foto",
            your_name: 'O teu nome',
            your_email: 'O teu e-mail',
        },
        hints: {
            organizer:
                'Quem organiza este evento? Um link para o site ou Instagram ajuda-nos a encontrar a marca certa.',
            end_date: "Num evento de um dia é a mesma data do início.",
            contact: 'Usamos apenas para te contactar sobre este evento.',
            photo: "Opcional. JPG, PNG ou WebP, até 8 MB.",
        },
        errors: {
            name: 'Indica o nome do evento.',
            start_date: 'Indica a data.',
            end_date: "Indica a data de fim.",
            event_category: "Escolhe um tipo de evento.",
            too_many: "Tentaste demasiadas vezes. Espera um pouco e tenta novamente.",
            city: 'Indica a cidade.',
            country: 'Escolhe um país.',
            organizer_name: 'Indique quem organiza este evento.',
            email: 'Indica um e-mail válido.',
            failed: 'O envio falhou. Tenta novamente daqui a pouco.',
            photo_type: "Escolhe um JPG, PNG ou WebP.",
            photo_size: "Esta foto é demasiado grande. Até 8 MB.",
        },
        submit: 'Enviar evento',
        done: {
            title: 'Obrigado, temos o teu evento',
            body: 'Alguém do LatinMap vai vê-lo. Vais receber uma confirmação por e-mail.',
            again: 'Enviar outro evento',
        },
        invalid: {
            title: 'Este link já não funciona',
            body: 'O link expirou ou foi retirado. Pede um novo a quem o enviou.',
        },
    },
    // LA-180: the screen Brevo returns to after a subscription is
    // confirmed. Top-level rather than under footer, because the same
    // confirmation ends both the footer form and the signup opt-in.
    newsletter: {
        // LA-176: the fixed sign-up landing page behind every QR code,
        // social bio and e-mail signature.
        stay_updated: {
            title: 'Fica perto da cena',
            lede: 'Recebe os eventos de dança latina pelos quais vale a pena guardar a noite — festas, festivais, workshops e aulas experimentais, além de novidades e passatempos da LatinMap.',
            benefits: {
                agenda: 'A agenda, antes de toda a gente',
                festivals: 'Festivais e congressos que valem a viagem',
                features: 'Novas funcionalidades da LatinMap assim que saem',
                community: 'Passatempos e notícias da comunidade',
            },
            form_title: 'Subscrever',
            email_label: 'O teu endereço de e-mail',
            submit: 'Juntar-me à lista',
            terms: 'Um e-mail de cada vez, e o teu endereço nunca vai para mais ninguém. Podes cancelar com um clique, em qualquer mensagem.',
            done: {
                title: 'Vê a tua caixa de entrada',
                body: 'Enviámos-te um e-mail. Clica no link para confirmar e ficas na lista.',
                again: 'Subscrever outro endereço',
            },
        },
        confirmed: {
            title: 'Inscrição confirmada',
            success: 'A tua inscrição está confirmada. Bem-vindo!',
            body: 'A partir de agora vais receber a newsletter da LatinMap: os melhores eventos de dança latina diretamente na tua caixa de entrada. Podes cancelar a subscrição com um clique em qualquer newsletter.',
            discover_events: 'Descobrir eventos',
            back_home: 'Voltar ao início',
        },
    },
    footer: {
        section_1: {
            title: 'Descubra o LatinMap',
            about: 'Sobre nós',
            how_it_works: 'Como funciona',
            search: 'Procurar',
            contact: 'Contato',
        },
        section_2: {
            title: 'Suporte e Comunidade',
            help: 'Centro de Ajuda e Perguntas Frequentes',
            privacy_policy: 'Política de Privacidade',
            terms_and_conditions: 'Termos e condições gerais de negócio',
            cookie_policy: 'Política de Cookies',
        },
        section_3: {
            title: 'para profissionais',
            create_event: 'Como criar um evento',
            create_organization: 'Como criar uma marca',
            become_ambassador: 'Torne -se um embaixador',
            promote_event: 'Como promover seu evento',
            professional_account_verification: 'Verificação de conta profissional'
        },
        section_4: {
            title: 'Categorias de dança e eventos',
            all_events: 'Todos os eventos',
        },
        follow_our_socials: 'Siga as nossas redes sociais',
    }
};
